<div class="row mb-2rem">
    <div class="col-sm-12 mb-2rem">
        <app-card [hidHeader]="true" cardClass="">

            <!--        FILTROS -->
            <div class="row">
                <div class="col-sm-12">
                    <form autocomplete="off" [formGroup]="buscarForm" (ngSubmit)="buscar()">
                        <div class="form-row">

                            <div class="form-group">
                                <div>Fecha Inicio</div>
                                <div class="input-group">
                                    <input class="form-control" autocomplete="off" id="lblFechaInicio" placeholder="dd/mm/yyy" name="lblFechaInicio"
                                        ngbDatepicker #dFechIni="ngbDatepicker" formControlName="lblFechaInicio"
                                    >
                                    <div class="input-group-append">
                                        <span class="input-group-text" (click)="dFechIni.toggle()">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                                <span class="form-text text-danger" *ngIf="ValidaCampo('lblFechaInicio')">Campo obligatorio</span>
                            </div>
                            <div class="form-group ml-2">
                                <div>Fecha Fin</div>
                                <div class="input-group">
                                    <input class="form-control" autocomplete="off" id="lblFechaFin" placeholder="dd/mm/yyy" name="lblFechaFin"
                                        ngbDatepicker #dFechFin="ngbDatepicker" formControlName="lblFechaFin"
                                    >
                                    <div class="input-group-append">
                                        <span class="input-group-text" (click)="dFechFin.toggle()">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                                <span class="form-text text-danger" *ngIf="ValidaCampo('lblFechaFin')">Campo obligatorio</span>
                            </div>
                            <div class="form-group ml-2">
                                <br>
                                <button class="btn btn-primary" type="submit"><i class="fas fa-search"></i> Buscar</button>
                                <br>
                            </div>

                            <div class="form-group col-md-2">
                                <br>
                                <a class="btn btn-primary float-right" (click)="diaAnterior()"><i class="fas fa-search"></i> Ayer</a>
                                <br>
                            </div>
                            <div class="form-group ml-2">
                                <br>
                                <a class="btn btn-primary" (click)="mesAnterior()"><i class="fas fa-search"></i> Mes Anterior</a>
                                <br>
                            </div>
                            <div class="form-group ml-2">
                                <br>
                                <a class="btn btn-primary" (click)="anioAnterior()"><i class="fas fa-search"></i> Año anterior</a>
                                <br>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
            <!-- FIN    FILTROS -->

            <div class="text-center mb-2rem">
                <app-card [hidHeader]="true" cardClass="card-datatable" [options]="false">

                    <app-loader *ngIf="cargarLoader"></app-loader>

                    <ng-container *ngIf="!cargarLoader && fechaInicio">
                        <h4>{{ fechaInicio | date: 'dd/MM/yyyy HH:mm:ss' }} - {{ fechaFin | date: 'dd/MM/yyyy HH:mm:ss' }}</h4>
                        
                        <div class="row">

                            <div class="col-sm-12 col-md-6 tabla-altura-personal" style="overflow-y: auto;">
                                <div class="chart-wrapper">
                                    <canvas baseChart [data]="dData" [labels]="dLabels" [chartType]="dType">
                                    </canvas>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <!--        TABLA -->
                                <div class="table-container-scroll">
                                    <div class="table-responsive tabla-altura-personal">
                                        <table class="table table-sm table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col" class="col-1 bg-primary text-white text-left">Nivel de Servicio</th>
                                                    <th scope="col" class="col-1 bg-primary text-white text-left">Cantidad</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="TotalNivelesIncidencia.length > 0">
                                                <tr *ngFor="let item of TotalNivelesIncidencia; let i = index">
                                                    <th class="text-wrap text-left">Nivel {{ item.nivelServicio }}</th>
                                                    <td class="text-wrap text-left">{{ item.total               }}</td>
                                                </tr>
                                                <tr>
                                                    <th colspan="2">&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th scope="col" class="col-1 bg-primary text-white text-left">Total         </th>
                                                    <th scope="col" class="col-1 bg-primary text-white text-left">{{ gTotal }}  </th>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="TotalNivelesIncidencia.length == 0">
                                                <tr>
                                                    <th colspan="2" style="color: red; font-size: 20px;">Sin datos</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- FIN    TABLA -->
                            </div>
                        </div>
                    </ng-container>
                </app-card>
            </div>
        </app-card>
    </div>
</div>